import * as React from "react";
const SvgMoney = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M6.833 11.172a3.25 3.25 0 1 0 6.279 1.682 3.25 3.25 0 0 0-6.279-1.682Zm2.686 2.531a1.75 1.75 0 1 1 .906-3.38 1.75 1.75 0 0 1-.906 3.38ZM8.966 7.084a.75.75 0 0 1-.53-.919l.13-.483a.75.75 0 0 1 1.448.389l-.13.483a.75.75 0 0 1-.918.53ZM9.932 17.955a.75.75 0 1 0 1.449.388l.13-.483a.75.75 0 1 0-1.45-.388l-.129.483Z"
      fill="currentColor"
    />
    <path
      d="M4 3.304a.75.75 0 0 1 .75-.75h2.075a.75.75 0 0 1 .918-.53l1.98.53h4.527a.75.75 0 0 1 .75.75v.665l1.92.514a.75.75 0 0 1 .53.918L15 14.543v5.261a.75.75 0 0 1-.75.75h-.86l-.24.891a.75.75 0 0 1-.918.53l-5.305-1.42H4.75a.75.75 0 0 1-.75-.75v-.035l-.944-.253a.75.75 0 0 1-.53-.919L4 13.095v-9.79Zm1.5.75v3.443l.923-3.443H5.5ZM4.17 18.262l7.727 2.07 3.91-14.594L8.08 3.667 4.168 18.262ZM16.5 16.003c0-.885.417-1.672 1.066-2.175a2.5 2.5 0 1 1 4.238 1.155 2.75 2.75 0 1 1-5.305 1.02Zm2.75-1.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm0-1.5c.599 0 1.154.191 1.605.517A1 1 0 1 0 19 13.253v.01a2.79 2.79 0 0 1 .25-.01Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgMoney;
